import axios from 'axios'
//获取字典-单个
export function getDicts (dictType) {
  return axios.get(`/system/dict/data/type/${dictType}`)
}

//获取某个类型字典列表
export function dictDataList (data) {
  return axios.get(`/system/dict/data/list`, { params: data })
}